import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation, Thumbs, Keyboard, Pagination } from "swiper/modules";
import "swiper/css";

// import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "../ProductDetails/styles.css";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Backdrop,
  Tooltip,
} from "@mui/material";

import { Add, DeleteRounded, EditRounded, Search } from "@mui/icons-material";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { productApi, updateProductApi, addProductApi } from "store/api";
import { useNavigate, useNavigation } from "react-router";

import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { Label } from "@mui/icons-material";
import Grid2 from "@mui/material/Unstable_Grid2";
import AddProductFromExcel from "../AddProductFromExcel";
import Success from "components/Success";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";

import { productUploadFromExcelApi } from "store/api";
import { getProductExcelApi } from "store/api";
import { deleteProductApi } from "store/api";
import { useSearchParams } from "react-router-dom";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ProductTab () {
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [msg, setMsg] = React.useState(false);
  const [products, setProducts] = React.useState([]);
  const [sheetProducts, setSheetProducts] = React.useState([]);
  const [noData, setNodata] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [openLoader, setOpenLoader] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenExcel = () => {
    setOpen(true);
  };

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [file, setFile] = React.useState(null);

  const handleFileChange = event => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async e => {
    e?.preventDefault();
    setOpenLoader(true);
    setOpen(false);
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await productUploadFromExcelApi(formData);
      if (response?.response?.data) {
        setOpen(true);
        setMsg(response?.response?.data?.message);
        setOpenSuccess(true);
        setSuccess(false);
        setOpenLoader(false);
        return;
      }
      if (response?.success) {
        setMsg("Products Uploaded Successfully");
        setOpenSuccess(true);
        setSuccess(true);
        // setOpen(false);
        FetchProduct();
        setOpenLoader(false);
      }
    } catch (error) {
      setOpen(true);
      setMsg("Something went wrong. Please try again after sometime.");
      setOpenSuccess(true);
      setSuccess(false);
      console.error("Error uploading file:", error);
      setOpenLoader(false);
    }
  };

  const FetchProduct = async searchTerm => {
    setLoader(true);
    setNodata(false);
    const params = !searchTerm
      ? { subCategoryId: id }
      : {
          searchKeyword: searchTerm,
          subCategoryId: id,
        };
    try {
      const response = await productApi(params);
      if (response?.success) {
        setLoader(false);
        setProducts(response?.data);
        if (!response?.data?.length) setNodata(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);

  const handleChangeProduct = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchProduct(value);
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  const redirectAdd = () => {
    navigate("/add-product");
  };

  const DeleteProduct = async productId => {
    setOpenLoader(true);
    const params = {
      productId: productId,
    };
    const response = await deleteProductApi(params);
    if (response?.response?.data) {
      setMsg(response?.response?.data?.message);
      setOpenSuccess(true);
      setSuccess(false);
      setOpenLoader(false);
      return;
    }
    if (response?.success) {
      setTimeout(() => {
        setMsg("Product Delete Successfully");
        setOpenSuccess(true);
        setSuccess(true);
        FetchProduct();
        setOpenLoader(false);
      }, [4000]);
    }
    if (!response?.success) {
      setMsg("Something went wrong. Please try again after sometime.");
      setOpenSuccess(true);
      setSuccess(false);
      setOpenLoader(false);
    }
  };
  const redirectEdit = productId => {
    navigate("/edit-product", { state: { productId: productId } });
  };
  React.useEffect(() => {
    FetchProduct();
  }, []);
  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Products</Typography>
        {/* <div style={{ display: "flex", gap: "20px" }}>
          <Button
            variant='contained'
            startIcon={<Add />}
            color='success'
            onClick={() => redirectAdd()}
          >
            Add New Product
          </Button>
        </div> */}
      </div>

      {/* Search and Rows Per Page */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeProduct}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div> */}

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Products' {...a11yProps(0)} />
            <Tab label='Active Products' {...a11yProps(1)} />
            <Tab label='Disable Products' {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {noData && <div>No Product found</div>}
            {loader && <CircularProgress color='success' />}
            {products?.length > 0 &&
              products?.map(e => (
                <ProductNew
                  DeleteProduct={DeleteProduct}
                  redirectEdit={redirectEdit}
                  redirect={redirect}
                  product={e}
                />
              ))}
          </Grid2>
          {/* <Grid container py={3} spacing={3}>
            {products?.length > 0 && products?.map(e => <Product redirect={redirect} e={e} />)}
          </Grid> */}
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {noData && <div>No Product found</div>}
            {loader && <CircularProgress variant='plain' />}
            {products?.length > 0 &&
              products?.map(
                e =>
                  e.isActive && (
                    <ProductNew
                      DeleteProduct={DeleteProduct}
                      redirectEdit={redirectEdit}
                      redirect={redirect}
                      product={e}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {products?.length == 0 && <div>No Product found</div>}
            {products?.length > 0 &&
              products?.map(
                e =>
                  !e.isActive && (
                    <ProductNew
                      DeleteProduct={DeleteProduct}
                      redirectEdit={redirectEdit}
                      redirect={redirect}
                      product={e}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
      </Box>
      <AddProductFromExcel
        open={open}
        file={file}
        handleClose={handleClose}
        handleSubmit={handleUpload}
        handleChange={handleFileChange}
      />
      <Backdrop
        sx={theme => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </div>
  );
}

const ProductNew = ({ product, DeleteProduct, redirect, redirectEdit }) => {
  // const [selectedColor, setSelectedColor] = React.useState("");
  // const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  // const handleColorChange = color => {
  //   setSelectedColor(color);
  // };
  // const currentColorData = product?.colors?.find(c => c.colorCode === selectedColor);
  // React.useEffect(() => {
  //   const activeColor = product?.colors?.find(color => color.isActive);
  //   if (activeColor) {
  //     setSelectedColor(activeColor.colorCode);
  //   }
  //   // if (product) setSelectedColor(product?.colors[0]?.colorCode);
  // }, [product]);

  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card style={{ position: "relative" }}>
        <div
          style={{
            zIndex: 9,
            top: 10,
            right: 10,
            position: "absolute",
            textTransform: "uppercase",
            display: "flex",
            gap: "10px",
          }}
        >
          <Tooltip title={"Edit"} onClick={() => redirectEdit(product?.productId)}>
            <EditRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
          </Tooltip>
        </div>
        <Swiper
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
            // borderRadius: "10px",
            height: "220px",
            position: "relative",
            cursor: "pointer",
          }}
          loop={true}
          spaceBetween={10}
          pagination={true}
          // thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Thumbs, Pagination]}
          className='mySwiper2'
          onClick={() => redirect(product)}
        >
          {product?.images?.length == 0 ? (
            <div
              style={{
                top: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                borderRadius: "16px 16px 0 0",
                flexDirection: "column",
                textTransform: "uppercase",
                gap: "16px",
              }}
            >
              <div
                style={{
                  border: "1px solid #636363",
                  backgroundColor: "rgba(170,170,170,0.35)",
                  borderRadius: "50%",
                  height: "40px",
                  width: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#636363",
                }}
              >
                <ImageNotSupportedIcon style={{ fontSize: "40px", fill: "#636363" }} />
              </div>
              <div style={{ fontSize: "10px" }}>Comming Soon</div>
            </div>
          ) : (
            <img
              alt='product'
              src={product?.images[0]?.image}
              style={{
                top: 0,
                width: "100%",
                height: "100%",
                zIndex: 2,
                objectFit: "cover",
                position: "absolute",
                borderRadius: "16px 16px 0 0",
              }}
            />
          )}
          {/* {currentColorData?.images.map((e, i) => (
            <SwiperSlide className='mySwiper5' style={{ position: "relative", minWidth: "220px" }}>
              <img
                alt='product'
                src={e.image}
                style={{
                  top: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 2,
                  objectFit: "cover",
                  position: "absolute",
                  borderRadius: "16px 16px 0 0",
                }}
              />
            </SwiperSlide>
          ))} */}
        </Swiper>

        <Stack
          spacing={2}
          sx={{ px: 3, py: 2, cursor: "pointer" }}
          onClick={() => redirect(product)}
        >
          <Link
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500", cursor: 'pointer' }}
            noWrap
          >
            {product?.name}
          </Link>

          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Typography
              variant='subtitle1'
              style={{
                fontSize: "0.875rem",
                fontWeight: "500",
                alignItems: "center",
                gap: "6px",
                display: "flex",
              }}
            >
              {product?.discountPrice}
              <div
                style={{
                  color: "red",
                  textDecoration: "line-through",
                  fontSize: "10px",
                  opacity: "0.6",
                }}
              >
                ₹{product?.price}
              </div>
            </Typography>
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};
